module.exports = __webpack_public_path__ + "static/img/AgAABXq0GNfiLyDlDWlN0Jw_HsHBi8eb.fc5c8c1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/帽子/AgAABXq0GNfiLyDlDWlN0Jw_HsHBi8eb.jpeg
// module id = iW3S
// module chunks = 0